<script>
import DocImage from '@/views/docs/DocImage'

export default {
  components: {
    DocImage
  },
  name: 'doc-image-grid',
  props: {
    columns: {type: Number, default: () => 3},
    images: {type: Array, default: () => []},
    title: {type: String, default: () => null}
  }
}
</script>
<template>
<div>
  <div v-if='title' class='title'>{{title}}</div>
  <v-row>
    <v-col v-for='(img, i) in images' :key='i' class='d-flex flex-column child-flex' :cols='12 / columns'>
      <DocImage v-bind='img' aspect-ratio='1'/>
    </v-col>
  </v-row>
</div>
</template>
